import { getRange } from "./utils";

export const MODULO_COINFLIP = 2;
export const MODULO_ROLLADICE = 6;
export const MODULO_TWODICE = 36;
export const MODULO_ROULETTE = 37;
export const MODULO_ETHEROLL = 100;

export const ROULETTE_NUMBERS = [
  0, 32, 15, 19, 4, 21, 2, 25, 17, 34, 6, 27, 13, 36, 11, 30, 8, 23, 10, 5, 24,
  16, 33, 1, 20, 14, 31, 9, 22, 18, 29, 7, 28, 12, 35, 3, 26,
];

export const RESULTS_TWODICE = {
  2: [[1, 1]],
  3: [
    [1, 2],
    [2, 1],
  ],
  4: [
    [1, 3],
    [2, 2],
    [3, 1],
  ],
  5: [
    [1, 4],
    [2, 3],
    [3, 2],
    [4, 1],
  ],
  6: [
    [1, 5],
    [2, 4],
    [3, 3],
    [4, 2],
    [5, 1],
  ],
  7: [
    [1, 6],
    [2, 5],
    [3, 4],
    [4, 3],
    [5, 2],
    [6, 1],
  ],
  8: [
    [2, 6],
    [3, 5],
    [4, 4],
    [5, 3],
    [6, 2],
  ],
  9: [
    [3, 6],
    [4, 5],
    [5, 4],
    [6, 3],
  ],
  10: [
    [4, 6],
    [5, 5],
    [6, 4],
  ],
  11: [
    [5, 6],
    [6, 5],
  ],
  12: [[6, 6]],
};

export function getTwoDiceResult(n) {
  const options = RESULTS_TWODICE[n];
  return options[Math.floor(options.length * Math.random())];
}

export function getDefaultInputs(modulo) {
  if (modulo === MODULO_COINFLIP) {
    return [1];
  } else if (modulo === MODULO_ROLLADICE) {
    const selection =
      START_OPTIONS_ROLLADICE[
        Math.floor(START_OPTIONS_ROLLADICE.length * Math.random())
      ];
    return selection.map((s) => s - 1);
  } else if (modulo === MODULO_TWODICE) {
    const selection =
      START_OPTIONS_TWODICE[
        Math.floor(START_OPTIONS_TWODICE.length * Math.random())
      ];
    return selection.map((s) => s + 2);
  } else if (modulo === MODULO_ROULETTE) {
    // return START_OPTIONS_ROULETTE[
    //   Math.floor(START_OPTIONS_ROULETTE.length * Math.random())
    // ];
    return [0,1,2,3]
  } else if (modulo === MODULO_ETHEROLL) {
    return [50];
  }
}

export const START_OPTIONS_ROLLADICE = [
  [1, 2, 3],
  [1, 2, 5],
  [1, 2, 6],
  [2, 3, 5],
  [2, 3, 6],
  [2, 5, 6],
  [3, 5, 6],
];

export const START_OPTIONS_TWODICE = [
  [5, 6, 7, 9, 10],
  [5, 6, 7, 8],
  [4, 6, 7, 8, 10],
  [4, 5, 7, 9, 10],
  [4, 5, 7, 8],
  [4, 5, 6, 9],
  [3, 6, 7, 8, 9],
  [3, 5, 7, 8, 10],
  [3, 5, 6, 9, 10],
  [3, 5, 6, 8],
  [3, 4, 7, 8, 9],
  [3, 4, 6, 8, 10],
  [3, 4, 6, 7],
  [3, 4, 5, 9, 10],
  [3, 4, 5, 8],
  [1, 5, 7, 8, 9, 10],
  [1, 5, 6, 8, 9],
  [1, 5, 6, 7, 10],
  [1, 4, 6, 8, 9, 10],
  [1, 4, 6, 7, 9],
  [1, 4, 5, 8, 9],
  [1, 4, 5, 7, 10],
  [1, 4, 5, 6],
  [1, 3, 6, 7, 9, 10],
  [1, 3, 6, 7, 8],
  [1, 3, 5, 8, 9, 10],
  [1, 3, 5, 7, 9],
  [1, 3, 5, 6, 10],
  [1, 3, 4, 7, 9, 10],
  [1, 3, 4, 7, 8],
  [1, 3, 4, 6, 9],
  [1, 3, 4, 5, 10],
  [0, 5, 6, 8, 9, 10],
  [0, 5, 6, 7, 9],
  [0, 4, 6, 7, 9, 10],
  [0, 4, 6, 7, 8],
  [0, 4, 5, 8, 9, 10],
  [0, 4, 5, 7, 9],
  [0, 4, 5, 6, 10],
  [0, 3, 6, 7, 8, 10],
  [0, 3, 5, 7, 9, 10],
  [0, 3, 5, 7, 8],
  [0, 3, 5, 6, 9],
  [0, 3, 4, 7, 8, 10],
  [0, 3, 4, 6, 9, 10],
  [0, 3, 4, 6, 8],
  [0, 3, 4, 5, 9],
  [0, 1, 6, 7, 8, 9, 10],
  [0, 1, 5, 7, 8, 9],
  [0, 1, 5, 6, 8, 10],
  [0, 1, 5, 6, 7],
  [0, 1, 4, 7, 8, 9, 10],
  [0, 1, 4, 6, 8, 9],
  [0, 1, 4, 6, 7, 10],
  [0, 1, 4, 5, 8, 10],
  [0, 1, 4, 5, 7],
  [0, 1, 3, 6, 8, 9, 10],
  [0, 1, 3, 6, 7, 9],
  [0, 1, 3, 5, 8, 9],
  [0, 1, 3, 5, 7, 10],
  [0, 1, 3, 5, 6],
  [0, 1, 3, 4, 8, 9, 10],
  [0, 1, 3, 4, 7, 9],
  [0, 1, 3, 4, 6, 10],
  [0, 1, 3, 4, 5],
];

const START_OPTIONS_ROULETTE = [getRouletteRed(), getRouletteBlack()];

export function getRouletteRed() {
  return [
    ...getRange(1, 10).filter((i) => i % 2),
    ...getRange(11, 18).filter((i) => i % 2 === 0),
    ...getRange(19, 28).filter((i) => i % 2),
    ...getRange(29, 36).filter((i) => i % 2 === 0),
  ];
}

export function getRouletteBlack() {
  return [
    ...getRange(1, 10).filter((i) => i % 2 === 0),
    ...getRange(11, 18).filter((i) => i % 2),
    ...getRange(19, 28).filter((i) => i % 2 === 0),
    ...getRange(29, 36).filter((i) => i % 2),
  ];
}

const GAMES = {
  2: {
    url: "/game/coinflip",
    name: "Coin flip",
    description: "50% win chance",
    description2: "Winning bet pays 1.98×",
    description3: "Pays 1.98×",
    iconUrl: "/img/coinflip.svg",
    alt: "coinflip icon",
    modulo: MODULO_COINFLIP,
    bg: "linear-gradient(0deg, rgba(192,58,255,1) 0%, rgba(135,76,252,1) 100%);",
    maxSelected: 1,
  },
  6: {
    url: "/game/rolladice",
    name: "Roll a dice",
    description: "Bet on numbers, 1 to 6",
    description2: "Winning bet pays up to 5.94×",
    description3: "Pays up to 5.94×",
    iconUrl: "/img/rolladice.svg",
    alt: "roll a dice icon",
    modulo: MODULO_ROLLADICE,
    bg: "linear-gradient(0deg, rgba(66,143,255,1) 0%, rgba(255,207,47,1) 100%);",
    maxSelected: 5,
  },
  36: {
    url: "/game/twodice",
    name: "Two dice",
    description: "Bet on sum, 2 to 12",
    description2: "Winning bet pays up to 35.64×",
    description3: "Pays up to 35.64×",
    iconUrl: "/img/twodice.svg",
    alt: "two dice icon",
    modulo: MODULO_TWODICE,
    bg: "linear-gradient(0deg, rgba(254,58,72,1) 0%, rgba(135,76,252,1) 100%);",
    maxSelected: 10,
  },
  37: {
    url: "/game/roulette",
    name: "Roulette",
    description: "Bet on sum, 2 to 12",
    description2: "Winning bet pays up to 35.64×",
    description3: "Pays up to 35.64×",
    iconUrl: "/img/roulette.svg",
    alt: "roulette icon",
    modulo: MODULO_ROULETTE,
    bg: "linear-gradient(0deg, #ef5960 0%, #ffd200 100%);",
    maxSelected: 36,
  },
  100: {
    url: "/game/etheroll",
    name: "Etheroll",
    description: "ANY win chance, 1% to 97%",
    description2: "Winning bet pays up to 97×",
    description3: "Pays up to 97×",
    iconUrl: "/img/etheroll.svg",
    alt: "etheroll icon",
    modulo: MODULO_ETHEROLL,
    bg: "linear-gradient(0deg, rgba(1,180,255,1) 0%, rgba(47,121,246,1) 100%);",
    maxSelected: 1,
  },
};

export default GAMES;
